export enum StateMatchType {
    EXACT = 1,
    STARTS_WITH = 2,
    CONTAINS = 3
}
